import {
    Component,
    Input,
} from '@angular/core';

@Component({
    selector: 'using-token-toro',
    templateUrl: './using-token-toro.component.html',
    styleUrls: ['./using-token-toro.component.scss'],
})
export class UsingTokenToroComponent {
    @Input()
    public onContinueClick: () => void;

    public currentPage = 0;
    private lastPage = 2;

    public goToNextPage() {
        if (this.currentPage < this.lastPage) {
            this.currentPage += 1;
        } else {
            this.currentPage = 0;
        }
    }

    public goToPreviousPage() {
        if (this.currentPage > 0) {
            this.currentPage -= 1;
        } else {
            this.currentPage = this.lastPage;
        }
    }

    public getPageActiveClass(pageNumber: number) {
        if (pageNumber === this.currentPage) {
            return 'indicator active';
        } else {
            return 'indicator';
        }
    }

    public getPageItemActiveClass(pageNumber: number) {
        if (pageNumber === this.currentPage) {
            return 'carousel-item';
        } else {
            return 'carousel-item hide';
        }
    }
}
